import { useHistory } from 'react-router-dom';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { ProjectStatus } from 'components/Dashboards/Portfolio/phasePerformance/components/projectStatus';
import { IPhasePerformanceContracts } from 'components/Dashboards/Portfolio/phasePerformance/phasePerformance.types';
import {
    getName,
    getProjectDate,
    isProjectTypical,
} from 'components/Dashboards/Portfolio/phasePerformance/phasePerformance.utils';
import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { Button } from 'components/DesignSystem/Button';
import classes from 'components/widgets/phasePerformanceBreakdown/phasePerformanceBreakdown.module.scss';

export const ErrorRow = ({ row, templateId }: { row: IPhasePerformanceContracts; templateId?: number }) => {
    const history = useHistory();
    const addMappingHandler = () => {
        history.push(
            `${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageMapProject.link}?templateId=${templateId}&contractId=${row.contract_id}`,
        );
    };
    const projectTypical: boolean = isProjectTypical(row);
    const projectTypicalClass = projectTypical ? classes.projectTypical : '';
    const projectName = getName(row);
    return (
        <div className={`${classes.row} ${projectTypicalClass}`}>
            <div className={`${classes.rowContainer}  ${classes.error}`}>
                <div className={classes.grouped}>
                    <div className={classes.groupItems}>
                        <div className={`${classes.item} ${classes.name}`}>
                            <div className={classes.projectName}>{projectName}</div>
                            <div className={classes.projectDate}>{getProjectDate(row)}</div>
                        </div>
                        <div className={`${classes.item} ${classes.status}`}>
                            {!projectTypical && <ProjectStatus status={row.status} projectName={projectName} />}
                        </div>
                        <div className={`${classes.item}  ${classes.error}`}>
                            <div className={classes.message}>
                                <MuiIcon
                                    icon={'warning'}
                                    color={'var(--button-primary-bg_destructive)'}
                                    fontSize={'30px'}
                                />
                                <div>{row.error}</div>
                            </div>

                            <Button
                                variant={'primary'}
                                type={'submit'}
                                id={'userProfileFormButtons_Save'}
                                onClick={addMappingHandler}
                            >
                                Edit Mapping
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
